module.exports = __webpack_public_path__ + "img/icon-energy-meter.ff97c639.svg";